"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Bucket = {
    type: "structure",
    required: [],
    members: {
        Name: {
            shape: {
                type: "string"
            }
        },
        CreationDate: {
            shape: {
                type: "timestamp"
            }
        }
    }
};
//# sourceMappingURL=_Bucket.js.map